import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
	standalone: false,
	selector       : 'app-technology-advantages',
	template       : `
		<section class="section technology-advantages">
			<div class="dot-area">
				<div class="section-main">
					<ng-content></ng-content>
				</div>
			</div>
		</section>
	`,
	encapsulation  : ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TechnologyAdvantagesComponent {
}